import { Container, Row } from "reactstrap";
import AddRows from "./AddRows";
import ChildRows from "./ChildRows";
import CustomFiltering from "./CustomFiltering";
import RowSelectionAndDeletion from "./RowSelectionAndDeletion";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { APIDataTablesTitle, DataTitle } from "../../../../../Constants/Constants";

const APIContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={APIDataTablesTitle} parent={DataTitle} />
      <Container fluid>
        <Row>
          <AddRows />
          <ChildRows />
          <RowSelectionAndDeletion />
          <CustomFiltering />
        </Row>
      </Container>
    </>
  );
};
export default APIContainer;
